import React from 'react';
import { Link } from 'react-router-dom';
import { newslettersMeta } from '../../newsletters.data.js';
import NewsletterSubscribe from '../../components/es/NewsletterSubscribe';
import { useAuth } from '../../context/AuthContext.jsx'; // 1. Importamos tu hook de autenticación

const NewsletterPage = () => {
    const { loggedIn } = useAuth(); // 2. Obtenemos el estado de autenticación

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
        }).format(date);
    };

    return (
        <div className="bg-gray-900 text-white min-h-screen font-sans">
            <header className="py-8 text-center border-b border-gray-800">
                <Link to="/" className="text-lg tracking-widest text-gray-400 hover:text-white transition-colors">
                    GUS•A•GUIAR
                </Link>
                <h1 className="mt-4 text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-emerald-300">
                    Newsletter
                </h1>
            </header>
            
            <main className="container mx-auto px-6 py-12 max-w-3xl">
                

                <div className="space-y-8">
                    {newslettersMeta
                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                        .map((meta) => (
                            <Link 
                                key={meta.slug} 
                                to={`/newsletter/${meta.campaign}/${meta.slug}`}
                                className="block p-6 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition-colors shadow-lg"
                            >
                                <p className="text-sm text-emerald-400 uppercase tracking-wider">{meta.campaign}</p>
                                <h2 className="text-2xl font-bold mt-1 text-white hover:text-emerald-300 transition-colors">{meta.title}</h2>
                                <p className="text-gray-400 mt-2">{formatDate(meta.date)}</p>
                            </Link>
                        ))
                    }
                </div>
                {/* 3. Renderizado Condicional del Formulario */}
                {/* Si el usuario NO está logueado, muestra el formulario de suscripción */}
                {!loggedIn && (
                    <div className="mb-20">
                        <NewsletterSubscribe />
                    </div>
                )}
            </main>
        </div>
    );
};

export default NewsletterPage;